<div class="row login-wrapper no-gutters position-relative">
    <img class="login-img" src="https://equityisdynamic-static.s3.amazonaws.com/misc/login.png">
    <div class="subtitle text-uppercase py-3 px-3 d-lg-none position-absolute">Equity is <i>Dynamic</i></div>
    <div class="col-12 col-lg-6">
        <div class="subtitle text-uppercase py-3 px-3 d-none d-lg-block">Equity is <i>Dynamic</i></div>
        <div class="py-5 px-3">
            <h1>password recovery</h1>
        </div>
        <form autocomplete="off" [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()" *ngIf="!submitted || f.email.errors">
            <div class="border-top">
                <div class="container-fluid py-4">
                    <div class="row">
                        <div class="col-12 col-lg-10 subtitle">Enter your email</div>
                    </div>
                    <div class="row pt-2">
                        <div class="col-12">
                            <input type="text" formControlName="email" class="form-control text-xlarge"
                                [ngClass]="{ 'is-invalid text-red': submitted && f.email.errors }" autocomplete="Off"
                                placeholder="me@email.com" />
                            <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                <div *ngIf="f.email.errors.required">Email is required</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="">
                <div class="container-fluid py-4">
                    <div class="row">
                        <div class="col">
                            <button [disabled]="loading" class="btn btn-primary px-5">
                                Submit
                            </button>
                            <div *ngIf="error" class="alert alert-danger mt-3 mb-0">{{error}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <div *ngIf="submitted && !f.email.errors">
            <div class="border-top">
                <div class="container-fluid py-4">
                    <div class="row">
                        <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                        <div *ngIf="!loading" class="col-12 col-lg-10 subtitle">We sent password recovery instructions to your e-mail.</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>